(function () {
  const root = document.querySelector('[data-zoony-collection]');
  if (!root) return;

  const cards = Array.from(root.querySelectorAll('[data-zc-card]'));
  const noResults = root.querySelector('[data-zc-no-results]');
  const visibleCountEl = root.querySelector('[data-zc-visible-count]');
  const filters = root.querySelector('[data-zc-filters]');
  const openBtn = root.querySelector('[data-zc-filters-open]');
  const closeBtn = root.querySelector('[data-zc-filters-close]');
  const backdrop = root.querySelector('[data-zc-filters-backdrop]');
  const clearBtn = root.querySelector('[data-zc-filters-clear]');
  const priceMinInput = root.querySelector('[data-zc-price-min]');
  const priceMaxInput = root.querySelector('[data-zc-price-max]');
  const priceMinLabel = root.querySelector('[data-zc-price-min-label]');
  const priceMaxLabel = root.querySelector('[data-zc-price-max-label]');
  const priceFill = root.querySelector('[data-zc-price-fill]');
  const priceRange = root.querySelector('[data-zc-price-range]');
  const priceTrack = root.querySelector('[data-zc-price-track]');
  const priceMinThumb = root.querySelector('[data-zc-price-thumb="min"]');
  const priceMaxThumb = root.querySelector('[data-zc-price-thumb="max"]');
  const sortRoot = root.querySelector('[data-zc-sort]');
  const sortTrigger = root.querySelector('[data-zc-sort-trigger]');
  const sortMenu = root.querySelector('[data-zc-sort-menu]');

  const moneyFactor = 100;
  const priceFloor = priceRange
    ? Number(priceRange.dataset.min)
    : Number(root.dataset.priceMin || 0);
  const priceCeil = priceRange
    ? Number(priceRange.dataset.max)
    : Number(root.dataset.priceMax || 0);
  const priceStep = priceRange
    ? Number(priceRange.dataset.step || 10)
    : Number(root.dataset.priceStep || 10);

  function selectedValues(name) {
    return Array.from(root.querySelectorAll(`[data-zc-filter="${name}"]:checked`)).map(
      (el) => el.value
    );
  }

  function snapToTen(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return priceFloor;
    return Math.round(n / priceStep) * priceStep;
  }

  function updatePriceUI() {
    if (!priceMinInput || !priceMaxInput) return;

    let minVal = snapToTen(priceMinInput.value);
    let maxVal = snapToTen(priceMaxInput.value);

    if (minVal > maxVal) {
      if (document.activeElement === priceMinInput) {
        maxVal = minVal;
        priceMaxInput.value = String(maxVal);
      } else {
        minVal = maxVal;
        priceMinInput.value = String(minVal);
      }
    }

    priceMinInput.value = String(minVal);
    priceMaxInput.value = String(maxVal);

    if (priceMinLabel) priceMinLabel.textContent = String(minVal);
    if (priceMaxLabel) priceMaxLabel.textContent = String(maxVal);

    const span = priceCeil - priceFloor;
    const leftPct = span > 0 ? ((minVal - priceFloor) / span) * 100 : 0;
    const rightPct = span > 0 ? ((maxVal - priceFloor) / span) * 100 : 100;

    if (priceFill) {
      priceFill.style.left = `${leftPct}%`;
      priceFill.style.width = `${Math.max(0, rightPct - leftPct)}%`;
    }
    if (priceMinThumb) {
      priceMinThumb.style.left = `${leftPct}%`;
      priceMinThumb.setAttribute('aria-valuenow', String(minVal));
    }
    if (priceMaxThumb) {
      priceMaxThumb.style.left = `${rightPct}%`;
      priceMaxThumb.setAttribute('aria-valuenow', String(maxVal));
    }
  }

  function applyFilters() {
    const vendors = selectedValues('vendor');
    const types = selectedValues('type');
    const colors = selectedValues('color');

    let minCents = null;
    let maxCents = null;
    if (priceMinInput && priceMaxInput) {
      const minVal = snapToTen(priceMinInput.value);
      const maxVal = snapToTen(priceMaxInput.value);
      const atDefaults = minVal <= priceFloor && maxVal >= priceCeil;
      if (!atDefaults) {
        minCents = Math.round(minVal * moneyFactor);
        maxCents = Math.round(maxVal * moneyFactor);
      }
    }

    let visible = 0;

    cards.forEach((card) => {
      const price = Number(card.dataset.price || 0);
      const vendor = card.dataset.vendor || '';
      const type = card.dataset.type || '';

      let show = true;
      if (minCents != null && price < minCents) show = false;
      if (maxCents != null && price > maxCents) show = false;
      if (vendors.length && !vendors.includes(vendor)) show = false;
      if (types.length && !types.includes(type)) show = false;
      if (colors.length) {
        const cardColors = (card.dataset.colors || '').split('|').filter(Boolean);
        if (!colors.some((c) => cardColors.includes(c))) show = false;
      }

      card.hidden = !show;
      if (show) visible += 1;
    });

    if (noResults) noResults.hidden = visible !== 0 || cards.length === 0;
    if (visibleCountEl) {
      visibleCountEl.textContent =
        cards.length === 0 ? '' : `${visible} / ${cards.length}`;
    }
  }

  function setDrawer(open) {
    if (!filters) return;
    filters.classList.toggle('is-open', open);
    if (backdrop) {
      backdrop.hidden = !open;
      backdrop.classList.toggle('is-open', open);
    }
    document.documentElement.classList.toggle('zc-filters-open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  function setSortOpen(open) {
    if (!sortTrigger || !sortMenu) return;
    sortTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    sortMenu.hidden = !open;
    if (sortRoot) sortRoot.classList.toggle('is-open', open);
  }

  function valueFromClientX(clientX) {
    if (!priceTrack) return priceFloor;
    const rect = priceTrack.getBoundingClientRect();
    if (rect.width <= 0) return priceFloor;
    const pct = Math.min(1, Math.max(0, (clientX - rect.left) / rect.width));
    return snapToTen(priceFloor + pct * (priceCeil - priceFloor));
  }

  function setDragging(which, clientX) {
    const next = valueFromClientX(clientX);
    let minVal = snapToTen(priceMinInput.value);
    let maxVal = snapToTen(priceMaxInput.value);
    if (which === 'min') {
      minVal = Math.min(next, maxVal);
      priceMinInput.value = String(minVal);
    } else {
      maxVal = Math.max(next, minVal);
      priceMaxInput.value = String(maxVal);
    }
    updatePriceUI();
    applyFilters();
  }

  function nearestThumb(clientX) {
    const val = valueFromClientX(clientX);
    const minVal = Number(priceMinInput.value);
    const maxVal = Number(priceMaxInput.value);
    return Math.abs(val - minVal) <= Math.abs(val - maxVal) ? 'min' : 'max';
  }

  let draggingThumb = null;

  function onPricePointerDown(e) {
    if (!priceMinInput || !priceMaxInput || !priceTrack) return;
    if (!e.target.closest('[data-zc-price-track]')) return;
    const thumb = e.target.closest('[data-zc-price-thumb]');
    draggingThumb = thumb ? thumb.getAttribute('data-zc-price-thumb') : nearestThumb(e.clientX);
    priceTrack.setPointerCapture(e.pointerId);
    setDragging(draggingThumb, e.clientX);
    e.preventDefault();
  }

  function onPricePointerMove(e) {
    if (!draggingThumb) return;
    setDragging(draggingThumb, e.clientX);
  }

  function onPricePointerUp() {
    draggingThumb = null;
  }

  function onPriceKeyDown(e) {
    const thumb = e.target.closest('[data-zc-price-thumb]');
    if (!thumb || !priceMinInput || !priceMaxInput) return;
    const which = thumb.getAttribute('data-zc-price-thumb');
    const dir = e.key === 'ArrowLeft' || e.key === 'ArrowDown' ? -1 : e.key === 'ArrowRight' || e.key === 'ArrowUp' ? 1 : 0;
    if (!dir) return;
    e.preventDefault();
    const current = which === 'min' ? Number(priceMinInput.value) : Number(priceMaxInput.value);
    const next = snapToTen(current + dir * priceStep);
    if (which === 'min') {
      priceMinInput.value = String(Math.min(Math.max(next, priceFloor), Number(priceMaxInput.value)));
    } else {
      priceMaxInput.value = String(Math.max(Math.min(next, priceCeil), Number(priceMinInput.value)));
    }
    updatePriceUI();
    applyFilters();
  }

  root.addEventListener('change', (e) => {
    if (e.target.matches('[data-zc-filter]')) applyFilters();
  });

  if (priceTrack) {
    priceTrack.addEventListener('pointerdown', onPricePointerDown);
    priceTrack.addEventListener('pointermove', onPricePointerMove);
    priceTrack.addEventListener('pointerup', onPricePointerUp);
    priceTrack.addEventListener('pointercancel', onPricePointerUp);
    priceTrack.addEventListener('keydown', onPriceKeyDown);
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      root.querySelectorAll('[data-zc-filter]').forEach((el) => {
        el.checked = false;
      });
      if (priceMinInput) priceMinInput.value = String(priceFloor);
      if (priceMaxInput) priceMaxInput.value = String(priceCeil);
      updatePriceUI();
      applyFilters();
    });
  }

  if (openBtn) openBtn.addEventListener('click', () => setDrawer(true));
  if (closeBtn) closeBtn.addEventListener('click', () => setDrawer(false));
  if (backdrop) backdrop.addEventListener('click', () => setDrawer(false));

  if (sortTrigger) {
    sortTrigger.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = sortTrigger.getAttribute('aria-expanded') !== 'true';
      setSortOpen(open);
    });
  }

  document.addEventListener('click', (e) => {
    if (sortRoot && !sortRoot.contains(e.target)) setSortOpen(false);
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      setDrawer(false);
      setSortOpen(false);
    }
  });

  updatePriceUI();
  applyFilters();
})();
